module.exports = __webpack_public_path__ + "img/whats-new-desktop_cn.ede0755.jpg";